<template>
  <div>
  <modal name="modal-termsandcondition" height="auto" width="546" :clickToClose="false" @before-open="beforeOpen" class="modal-page terms andcon" :adaptive="true">

    <div class="temscon">
      <a v-if="iconClose" @click="close" class="ui basic button close">Close</a>
      <div class="ui grid container modal-summary terms con">
        <div class="details terms">
          <div class="paragraph">
            <label>TERMS OF SERVICE AND PRIVACY POLICY</label>
            <p>
              By using and accessing the Cashalo Merchant Onboarding Webpage (the “Webpage”), you signify that you have read and understood these Terms of Service and agree to be bound by the same. Upon your use of this Webpage, these Terms of Service shall be a binding agreement between you and Oriente Express Techsystem Corporation (the “Company”). If you do not agree, do not fully understand or have reservations with respect to any provision of these Terms of Service, please exit this Webpage.
            </p>
          </div>

          <div class="paragraph">
            <label>ELIGIBILITY</label>
            <p>
              This Webpage is intended solely for the use of persons or entities doing business as seller of goods and services  (“Merchant”), in good credit standing, and have the legal capacity to enter into binding agreements, specifically for the
              availment of business opportunities with the Company.
            </p>
            <p>
              By filling out and submitting the Merchant Onboarding Form in this Webpage, you represent and warrant that you possess the foregoing eligibility requirements. You likewise expressly authorize the Company to use all necessary means to verify your identity (including sharing information, personal and non-personal, you have provided) with any third party service provider and/or data controller.
            </p>
          </div>
          <div class="paragraph">
            <label>REGISTRATION AND SUBMISSION OF THE MERCHANT ONBOARDING FORM</label>
            <p>
              In submitting the Merchant Onboarding Form, you agree to provide the true, current, complete and accurate information about yourself in the said form which is necessary for purposes of evaluating potential partnership with the Company and in your capacity as a merchant. If any information you provide is untrue, inaccurate, not current, or incomplete, we reserve the right to cancel your registration and reject the form you have submitted.
            </p>
          </div>

          <div class="paragraph">
            <label>PRIVACY</label>
          </div>
          <div class="paragraph">
            <label>Statement of Policy</label>
            <p>
              Upon submission of the Merchant Onboarding Form, the Company will reach out to you to discuss business opportunities with the Company, its affiliates, and existing partners.
            </p>
            <p>
              We value your privacy and we are committed to the protection of any and all personal information which you may provide when using this Webpage and in submitting the Merchant Onboarding Form, in compliance with Republic Act No. 10173 or the Data Privacy Act of 2012.
            </p>
            <p>
              In this privacy policy, we inform you (1) what personal information is collected from you; (2) how we collect and protect your personal information; (3) why we are collecting your personal information; and (4) upon your further consent if so required, to whom we share your personal information and for what purpose.
            </p>
          </div>
          <div class="paragraph">
            <label>PERSONAL INFORMATION COLLECTED AND HANDLED</label>
            <p>
              In signifying your interest in partnering with us, we will be collecting the following information: (1) Full Name; (2) Email Address; (3) Mobile Number; (4) Business Name; (5) Position; and (6) Business Website details.
            </p>
            <p>
              We also collect the above personal information from you when you send us inquiries at cashalosales@cashalo.com
            </p>
          </div>
          <div class="paragraph">
            <label>USE/PURPOSE</label>
            <p>
              The Personal Information is collected, processed, used, disclosed, stored and retained for the following purposes:
            </p>
            <p>
              <ul>
                <li>
                  To communicate with you partnership opportunities with the Company, its affiliates, and partners
                </li>
                <li>
                  To become a partner with the Company, its affiliates, and partners
                </li>
                <li>
                  To receive calls, messages, emails, and updates from the Company, its affiliates and partners on existing or future products and services
                </li>
                <li>
                  For market research, statistical analyses, or other research to improve the products and services of the Company, its affiliates, and partners, and customer satisfaction analysis
                </li>
                <li>
                  To respond to inquiries sent to cashalosales@cashalo.com 
                </li>
              </ul>
            </p>
          </div>
          <div class="paragraph">
            <label>SHARING OF PERSONAL INFORMATION</label>
            <p>
              Your Personal Information may be shared by the Company with its assigns, affiliates, and related companies (the “Oriente Group”) and the Company and Oriente Group’s partners in the conduct of its business for processing as may be required in the maintenance and performance of its business activities.
            </p>
            <p>
              The Oriente Group may, as necessary, be engaged by the Company as subcontractors or data processors in each case with respect to the purposes enumerated above.
            </p>
            <p>
              All data processing, subcontracting or data sharing agreements will be in accordance with the requirements under the Data Privacy Act of 2012, or applicable laws and regulations. To the extent that such processing, subcontracting, or data sharing requires notice or consent, we will provide you notice or request for your consent, in each case, prior to any processing or sharing of your Personal Information.
            </p>
          </div>
          <div class="paragraph">
            <label>RETENTION OF PERSONAL INFORMATION</label>
            <p>
              Your Personal Information will be retained by the Company for as long as needed and necessary to achieve the above-mentioned use/purposes for which it was collected and for such period of time required for legal and regulatory purposes.
            </p>
            <p>
              Your Personal Information will be disposed of in a secure manner that would prevent further processing, unauthorized access or disclosure to any other party or the public, provided that the Company may retain copies of your Personal Information in the Company’s archives pursuant to its bona fide record retention or data back-up policies, access to which shall be restricted on a need-to-know basis, as may be required under the applicable laws and regulations.
            </p>
          </div>
          <div class="paragraph">
            <label>SECURITY OF YOUR PERSONAL INFORMATION</label>
            <p>
              The Company values your Personal Information collected, used, or stored through the Webpage, and we will ensure that it is protected from possible threats, both online and offline. The Company has the necessary technical, organizational and physical measures to ensure that your Personal Information is kept safe and secure, as well as to prevent unauthorized access or disclosure of the collected and stored Personal Information.
            </p>
          </div>
          <div class="paragraph">
            <label>LOG DATA</label>
            <p>
              When a User or visitor visits and/or uses the webpage, the User’s or visitor’s browser/interface may send the Company personal information which the Company collects for statistical and internal record-keeping purposes. The process of collecting this information is called “Log Data”, and may include information such as the computer’s Internet Protocol (IP) address, browser type, browser version, the visited pages of the Website, the time and date of the visit, time spent on the pages, and other statistics.
            </p>
          </div>
          <div class="paragraph">
            <label>COOKIES</label>
            <p>
              A cookie is a small file which asks permission to be placed on the visitor’s computer hard drive. Once the visitor agrees, the file is added and the cookie helps analyze web traffic or provides internet usage information. A visitor can instruct his or her browser to refuse all cookies or to indicate when a cookie is being sent. However, if the visitor does not accept cookies, the visitor may not be able to use some portions of the website. A cookie in no way gives the Company access to the visitor’s computer or any information about the visitor, other than the data the visitor chooses to share with the Company.
            </p>
          </div>
          <div class="paragraph">
            <label>CHANGES IN OUR PRIVACY POLICY</label>
            <p>
              This Privacy Policy is in effect as of March 1, 2021 and shall continue to remain in effect unless otherwise changed or amended.
            </p>
            <p>
              The Company reserves the right to amend this Privacy Policy from time to time, upon due notification to its Users or visitors.
            </p>
            <p>
              If significant changes to this Privacy Policy will affect certain Personal Information, the Company shall notify its Users through the email address provided or by posting a public notice on the website.
            </p>
          </div>
          <div class="paragraph">
            <label>ACCESS AND CORRECTION OF PERSONAL INFORMATION</label>
            <p>
              You may contact us if you wish to exercise your rights to access, correct, cancel, and object to personal information you have submitted, get a copy of the personal information we have generated, or if you have any inquiries regarding the protection of your personal information.

              <br><br>
              You may send an email to dpo@cashalo.com.
            </p>
          </div>

          <div class="paragraph">
            <label>ACCEPTANCE</label>
            <p>I confirm having read and understood and agree to the foregoing Terms of Use and Privacy Policy.</p>
          </div>
          <a @click="close" class="ui button orange">OK</a>
        </div>
      </div>
    </div>
  </modal>

</div>
</template>
<script>

export default {
  name:'modal-termsandcondition',
  data() {
    return {
      iconClose: true
    }
  },
  methods: {
    close() {
      this.$modal.hide('modal-termsandcondition');
    },

    beforeOpen() {
      this.closebtn = true
      $('.vm--modal').addClass('terms')
    },
    checkwindow() {
      if ($(window).width() >= 900) {
        this.iconClose = true
      } else {
        this.iconClose = false
      }
    }
  },

  mounted() {
    this.closebtn = false,
    this.checkwindow()
  }
}
</script>
